import React from "react";
import classNames from "classnames";
import { PostmatchSummaryBlocksItem } from "../postmatch-summary-blocks-item/postmatch-summary-blocks-item";
import styles from "./postmatch-summary-blocks.module.css";

export function PostmatchSummaryBlocks({
  postmatchCompany,
  isLoading,
  styleLeft,
  enableHoursBilled,
  enableMargins,
}: any) {
  return (
    <div
      className={classNames(styles.summaryBlocks, {
        [styles.left]: styleLeft,
      })}
    >
      <PostmatchSummaryBlocksItem
        name="Active contractors"
        value={postmatchCompany?.totalActiveDevelopers}
        isLoading={isLoading}
        styleLeft={styleLeft}
      />
      {enableHoursBilled && (
        <PostmatchSummaryBlocksItem
          name="Hours billed"
          value={postmatchCompany?.billedHours}
          isLoading={isLoading}
          styleLeft={styleLeft}
        />
      )}
      <PostmatchSummaryBlocksItem
        name="Engagement starts"
        value={postmatchCompany?.totalEngagementsStarts}
        isLoading={isLoading}
        styleLeft={styleLeft}
      />
      <PostmatchSummaryBlocksItem
        name="Engagement ends"
        value={postmatchCompany?.totalEngagementsStops}
        isLoading={isLoading}
        styleLeft={styleLeft}
      />
      {enableMargins && (
        <PostmatchSummaryBlocksItem
          name="Total Margin"
          value={postmatchCompany?.totalMargin?.marginText}
          isLoading={isLoading}
          styleLeft={styleLeft}
        />
      )}
      {enableMargins && (
        <PostmatchSummaryBlocksItem
          name="Average Margin Per Dev"
          value={postmatchCompany?.averageMarginPerDev?.marginText}
          isLoading={isLoading}
          styleLeft={styleLeft}
        />
      )}
    </div>
  );
}
